"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
import { Vue, Component, PropSync } from "vue-property-decorator";
import DateFormat from "@/framework/timeformatter";
let ItemElementDeployDate = class extends Vue {
  mounted() {
  }
  remoteLauncher() {
    this.$emit("remoteLauncher");
  }
  formatdate(date) {
    if (date === 0 || date === null) {
      return "--";
    } else {
      return DateFormat.format_open_date(DateFormat.check(date));
    }
  }
};
__decorateClass([
  PropSync("item")
], ItemElementDeployDate.prototype, "_item", 2);
ItemElementDeployDate = __decorateClass([
  Component({
    components: {}
  })
], ItemElementDeployDate);
export {
  ItemElementDeployDate as default
};
